// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.v-dialog__content .v-dialog[data-v-6d7cde8f] .v-card,
.application .theme--light.v-stepper[data-v-6d7cde8f],
.theme--light .v-stepper[data-v-6d7cde8f] {
  background: #fafafa;
}
.v-dialog[data-v-6d7cde8f] .v-stepper {
  background: inherit;
}
.v-dialog .v-stepper[data-v-6d7cde8f] .v-stepper__header {
  box-shadow: none;
  text-transform: uppercase;
}
.v-dialog .v-stepper[data-v-6d7cde8f] .v-stepper__content {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0;
}
.application .theme--light.v-stepper .v-stepper__step--editable[data-v-6d7cde8f]:hover,
.theme--light .v-stepper .v-stepper__step--editable[data-v-6d7cde8f]:hover {
  background: none;
}
.shadow-outer[data-v-6d7cde8f] {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}
.enquiry-step3[data-v-6d7cde8f] {
  width: 240px;
}
.v-form > .container > .layout[data-v-6d7cde8f]:only-child {
  margin: 0;
}
.v-input__slot[data-v-6d7cde8f] {
  margin-bottom: 0;
}
.v-text-field__details[data-v-6d7cde8f] {
  color: inherit;
  display: flex;
  padding-top: 4px;
  flex: 1 0 100%;
  font-size: 12px;
  min-height: 26px;
  overflow: hidden;
  position: relative;
  width: 100%;
  align-items: center;
}
.policy-logo[data-v-6d7cde8f] {
  width: 118px;
  height: 100%;
  webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  position: relative;
}
.policy-logo img[data-v-6d7cde8f] {
  padding: 0px 15px;
  width: 100%;
  margin: auto;
  position: ABSOLUTE;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.emergency-info-table[data-v-6d7cde8f] {
  width: 100%;
  padding-left: 15px;
}
.emergency-info-table .shadow-outer.emergency-table[data-v-6d7cde8f] {
  height: 100%;
}
.emergency-info-table .shadow-outer.emergency-table[data-v-6d7cde8f] {
  height: 100%;
}
.search-job-item > div[data-v-6d7cde8f] {
  position: relative;
}
.search-job-item .seach-loader[data-v-6d7cde8f] {
  position: absolute !important;
  top: 13px;
  right: 35px;
  margin: 0px;
}
.search-job-item .v-input[data-v-6d7cde8f] {
  position: relative;
}
.search-job-item .v-input .v-input__prepend-outer[data-v-6d7cde8f] {
  margin: 0;
}
.search-job-item .v-input .v-input__icon--prepend[data-v-6d7cde8f] {
  position: absolute;
  left: 0;
}
.search-job-item .v-input .v-text-field__details[data-v-6d7cde8f] {
  max-width: calc(100% - 0px);
}
.search-job-item .v-input__slot[data-v-6d7cde8f] {
  padding-left: 40px;
  padding-right: 40px;
}
.search-job-item .v-input .v-select__slot .v-input__append-inner[data-v-6d7cde8f] {
  position: absolute;
  right: -30px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
